import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, mergeProps as _mergeProps, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-43714c8c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "report-page" }
const _hoisted_2 = { class: "table ws_common_table" }

import { onMounted, ref } from 'vue'
import AdvancedQueryLayout from '@/components/advanced-query-layout'
import { queryReportPage, exportReportData, deleteReport } from '@/api'
import ReportData from './components/report-data.vue'
import ReportChart from './components/report-chart.vue'
import { isEmpty } from 'lodash'
import moment from 'moment'
import { useRoute } from 'vue-router'
import { CODE_ENUM, PAGE_SIZES, REPORT_DATA_TYPE } from '@/common'
import { ElMessage } from 'element-plus'
import i18n from '@/i18n'
import OperationButtonList from '@/components/operation-button-list'
import { msgbox, downLoadFile } from '@/utils'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const t = i18n.global.t

const buttonList = ref([
  {
    type: 'detail',
    text: t('STATISTICS.rview'),
  },
  {
    type: 'view',
    text: t('STATISTICS.rchart'),
  },
  {
    type: 'export',
    text: t('STATISTICS.rexport'),
  },
  {
    type: 'delete',
    text: t('STATISTICS.rdelete'),
  },
])

const dataType = [
  {
    label: t('STATISTICS.rfdataType1'),
    value: REPORT_DATA_TYPE.ORIGIN,
  },
  {
    label: t('STATISTICS.rfdataType2'),
    value: REPORT_DATA_TYPE.AGGREGATION,
  },
]

const $route = useRoute()

const advancedRef = ref()

const formInline: any = ref({
  reportName: undefined,
  dataType: undefined,
})

onMounted(async () => {
  fetchList()
})

const handleSizeChange = () => {
  pageParams.value.curPage = 1
  fetchList()
}
const handleCurrentChange = () => {
  fetchList()
}

const pageParams = ref({
  curPage: 1,
  pageSize: 10,
})
const total = ref(0)
const columns: any = [
  {
    label: t('STATISTICS.reportName'),
    prop: 'reportName',
  },
  {
    label: t('STATISTICS.dateType'),
    prop: 'dataType',
  },
  {
    label: t('STATISTICS.executionType'),
    prop: 'executeDesc',
  },
  {
    label: t('STATISTICS.rexecutionStatus'),
    prop: 'executeStatus',
  },
  {
    label: t('STATISTICS.rexecutionTime'),
    prop: 'executeTime',
    formatter: ({ executeTime }: any) => {
      return moment(executeTime).format('YYYY-MM-DD HH:mm:ss')
    },
  },
]

const tableData = ref([])
const tableLoading = ref(false)
const fetchList = async (queryData?: any) => {
  const keepAliveData = advancedRef.value.getKeepAliveData() || {}
  const { data, reset } = queryData || {}
  if (typeof reset === 'boolean') {
    pageParams.value.curPage = 1
  }
  tableLoading.value = true
  const res: any = await queryReportPage({
    ...pageParams.value,
    ...data,
    ...keepAliveData,
  }).finally(() => {
    tableLoading.value = false
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    total.value = res?.data?.total || 0
    tableData.value = res?.data?.records || []
  }
}

const chartConf = ref({
  visible: false,
  data: {},
})
const toChart = (data: any) => {
  chartConf.value = {
    visible: true,
    data,
  }
}

const dataConf = ref({
  visible: false,
  data: {},
})

const toData = (data: any) => {
  dataConf.value = {
    visible: true,
    data,
  }
}

const toExport = async ({ id }: any) => {
  const res: any = await exportReportData({
    id,
    curPage: 1,
    pageSize: 10,
  })
  if (res?.msg?.code === CODE_ENUM.SUCCESS) {
    downLoadFile(res)
  }
}

const toDelete = (row: any) => {
  msgbox({
    tip: t('STATISTICS.rdelTip'),
    thenFn: () => handleDelete(row),
  })
}

const handleDelete = async ({ id }: any) => {
  const res: any = await deleteReport({ id })
  if (res?.code === CODE_ENUM.SUCCESS) {
    ElMessage.success(res?.msg)
    fetchList()
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(AdvancedQueryLayout), {
      class: "advanced-wrapper",
      ref_key: "advancedRef",
      ref: advancedRef,
      model: formInline.value,
      onFetchList: fetchList,
      border: true
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: _ctx.$t('STATISTICS.rfName'),
          prop: "reportName"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: formInline.value.reportName,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formInline.value.reportName) = $event)),
              placeholder: _ctx.$t('STATISTICS.rfNamePla'),
              class: "ws_select",
              clearable: ""
            }, null, 8, ["modelValue", "placeholder"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, {
          label: _ctx.$t('STATISTICS.dateType'),
          prop: "dataType"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: formInline.value.dataType,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formInline.value.dataType) = $event)),
              filterable: "",
              placeholder: _ctx.$t('STATISTICS.rfDateTypePla'),
              class: "ws_select",
              clearable: ""
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(dataType, (item) => {
                  return _createVNode(_component_el_option, {
                    key: item.value,
                    label: item.label,
                    value: item.value
                  }, null, 8, ["label", "value"])
                }), 64))
              ]),
              _: 1
            }, 8, ["modelValue", "placeholder"])
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _: 1
    }, 8, ["model"]),
    _createElementVNode("div", _hoisted_2, [
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: tableData.value,
        style: {"width":"100%"}
      }, {
        empty: _withCtx(() => [
          _createVNode(_component_el_empty, {
            description: _ctx.$t('STATISTICS.noData')
          }, null, 8, ["description"])
        ]),
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(columns, (item) => {
            return _createVNode(_component_el_table_column, _mergeProps({
              key: item.prop
            }, {
            ...item,
          }, { "show-overflow-tooltip": "" }), null, 16)
          }), 64)),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('STATISTICS.operation'),
            prop: "enableStatus",
            width: "460"
          }, {
            default: _withCtx((scoped) => [
              _createVNode(_unref(OperationButtonList), {
                buttonList: buttonList.value,
                scope: scoped.row,
                onOnDetail: toData,
                onOnExport: toExport,
                onOnView: toChart,
                onOnDelete: toDelete
              }, null, 8, ["buttonList", "scope"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["data"])), [
        [_directive_loading, tableLoading.value]
      ]),
      _createVNode(_component_el_pagination, {
        class: "ws_mt50",
        "current-page": pageParams.value.curPage,
        "onUpdate:currentPage": _cache[2] || (_cache[2] = ($event: any) => ((pageParams.value.curPage) = $event)),
        "page-size": pageParams.value.pageSize,
        "onUpdate:pageSize": _cache[3] || (_cache[3] = ($event: any) => ((pageParams.value.pageSize) = $event)),
        "page-sizes": _unref(PAGE_SIZES),
        layout: "->, total, sizes, prev, pager, next, jumper ",
        total: total.value,
        onSizeChange: handleSizeChange,
        onCurrentChange: handleCurrentChange
      }, null, 8, ["current-page", "page-size", "page-sizes", "total"])
    ]),
    _createVNode(ReportData, {
      visible: dataConf.value.visible,
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => ((dataConf.value.visible) = $event)),
      data: dataConf.value.data
    }, null, 8, ["visible", "data"]),
    _createVNode(ReportChart, {
      visible: chartConf.value.visible,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((chartConf.value.visible) = $event)),
      data: chartConf.value.data
    }, null, 8, ["visible", "data"])
  ]))
}
}

})